import SuccessTemplate from './success';

export {SuccessTemplate};
